export default __webpack_public_path__ + "static/images/plugin-seedprod.png?0ea95f2a06d52e3ec18c5859a9947097";